import { useLanguage } from "@/context/LanguageContext";

export default function CookieBanner({ open, onAccept }) {
  const { t } = useLanguage();
  if (!open) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 sm:left-6 sm:max-w-sm z-[60] bg-ink text-cream p-6 border border-gold/40 shadow-xl"
    >
      <p className="text-sm text-cream/85 leading-relaxed mb-4">{t("cookie.text")}</p>
      <button
        onClick={onAccept}
        data-testid="cookie-accept"
        className="bg-gold text-ink px-6 py-2.5 text-[11px] tracking-[0.2em] uppercase hover:bg-cream transition-colors"
      >
        {t("cookie.accept")}
      </button>
    </div>
  );
}
